export enum PreSelectSubSection {
    All = 1,
    Pending = 2,
    Accepted = 3,
    Declined = 4
}